import {
	Component,
	OnInit,
	OnDestroy,
	OnChanges,
	Input,
	SimpleChanges,
	Optional,
	Output,
	EventEmitter
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";

import { IdService } from "../shared/services/id.service";

import { ICrumb } from "./breadcrumb.interface";

@Component({
	selector: "rbc-breadcrumb",
	template: `
		<nav [id]="id" [attr.aria-label]="ariaLabel">
			<ol class="rbc-breadcrumb">
				<li *ngFor="let item of items; index as index" class="rbc-breadcrumb-item">
					<a
						[id]="id+'Item'+index"
						*ngIf="item.link && item.link != '#' && !item.href"
						[class]="getLinkClass(item.link)"
						[routerLink]="item.link"
						[queryParams]="item.queryParams"
						routerLinkActive="active"
						[routerLinkActiveOptions]="{exact:true}"
						[href]= "item.link ? item.link : null">
						{{ item.text }}
					</a>
					<a
						[id]="id+'Item'+index"
						*ngIf= "(!item.link || item.link == '#') && item.href"
						[class]="getLinkClass(item.link)"
						[href]="item.href"
					>
						{{ item.text }}
					</a>
					<span
						[id]="id+'Item'+index"
						*ngIf="(!item.link || item.link == '#') && !item.href"
						[class]="getLinkClass(item.link)"
					>
						{{ item.text }}
					</span>
				</li>
			</ol>
		</nav>
	`,
	styles: []
})
export class BreadcrumbComponent implements OnChanges, OnDestroy {
	@Input() id: string;
	@Input() items: ICrumb[];
	@Input() ariaLabel: string;

	@Input() set href(v: string) {
		this._href = v;
	}

	get href() {
		return this.domSanitizer.bypassSecurityTrustUrl(this._href) as string;
	}

	/**
	 * Emits the navigation status promise when the link is activated
	 */
	@Output() navigation = new EventEmitter<Promise<boolean>>();

	protected _href;

	constructor(
		private idService: IdService,
		protected domSanitizer: DomSanitizer,
		private router: Router
	) {
		this.id = this.idService.generate();
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (Array.isArray(this.items)) {
			this.items = this.items.filter(item => {
				return !!item.text && item.text !== "";
			});
		}
	}

	/* utils */
	getLinkClass(link: string) {
		return link && link !== "#" ? "rbc-breadcrumb-link" : "";
	}
}
